module.exports = __webpack_public_path__ + "img/22.f119c02f.png";